import React from 'react';
import {
  Box,
  Typography,
  Fade,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
} from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../hooks';
import { dashboardHeroStyles as sx } from './DashboardHero.styles';

const MONTHS = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];

const DashboardHero = ({
  showTeamFilter = false,
  showPersonFilter = false,
  teams = [],
  teamUsers = [],
  selectedTeamId = null,
  selectedUserId = null,
  onTeamChange,
  onUserChange,
}) => {
  const { t } = useTranslation();
  const { userDisplayName } = useAuth();
  const now = new Date();
  const dateLabel = `${now.getDate()} ${MONTHS[now.getMonth()]} ${now.getFullYear()}`;

  return (
    <Fade in timeout={400}>
      <Box sx={sx.section}>
        <Box sx={sx.content}>
          <Box sx={sx.left}>
            <Typography sx={sx.title}>
              {t('dashboard.welcome')}{userDisplayName ? `, ${userDisplayName}` : ''}
              <Box component="span" sx={sx.wave} role="img" aria-label="wave">👋</Box>
            </Typography>
            <Typography sx={sx.subtitle}>
              {t('dashboard.subtitle')}
            </Typography>
          </Box>

          <Box sx={sx.right}>
            <Box sx={sx.dateBadge}>
              <CalendarTodayIcon sx={sx.dateIcon} />
              {dateLabel}
            </Box>

            {showTeamFilter && (
              <FormControl size="small" sx={sx.filterControl}>
                <Select
                  value={selectedTeamId ?? ''}
                  displayEmpty
                  onChange={(e) => onTeamChange?.(e.target.value ? parseInt(e.target.value) : null)}
                  startAdornment={
                    <InputAdornment position="start">
                      <GroupsIcon sx={sx.selectAdornment} />
                    </InputAdornment>
                  }
                  renderValue={(v) => {
                    if (!v) return t('dashboard.filters.selectTeam');
                    const team = teams.find((tm) => tm.id === v);
                    return team?.name || t('dashboard.filters.selectTeam');
                  }}
                >
                  <MenuItem value="">{t('dashboard.filters.all')}</MenuItem>
                  {teams.map((team) => (
                    <MenuItem key={team.id} value={team.id}>
                      {team.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {showPersonFilter && (
              <FormControl
                size="small"
                sx={sx.filterControl}
                disabled={showTeamFilter && !selectedTeamId}
              >
                <Select
                  value={selectedUserId ?? ''}
                  displayEmpty
                  onChange={(e) => onUserChange?.(e.target.value ? parseInt(e.target.value) : null)}
                  startAdornment={
                    <InputAdornment position="start">
                      <PersonOutlineIcon sx={sx.selectAdornment} />
                    </InputAdornment>
                  }
                  renderValue={(v) => {
                    if (!v) return t('dashboard.filters.selectUser');
                    const u = teamUsers.find((tu) => tu.id === v);
                    return u ? `${u.first_name} ${u.last_name}` : t('dashboard.filters.selectUser');
                  }}
                >
                  <MenuItem value="">{t('dashboard.filters.all')}</MenuItem>
                  {teamUsers.map((u) => (
                    <MenuItem key={u.id} value={u.id}>
                      {u.first_name} {u.last_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

export default DashboardHero;
